import { useEffect } from "react";
import { api } from "@/lib/apiClient";

/**
 * Aplica o título da aba do navegador e o favicon configurados pelo
 * Superadmin (Admin > Identidade Visual). Roda em TODA carga de página,
 * inclusive na tela de login/registro, pois não depende de autenticação.
 * Não renderiza nada na tela.
 */
export default function BrandingLoader() {
  useEffect(() => {
    let cancelled = false;
    api
      .get("/public/branding")
      .then(({ data }) => {
        if (cancelled || !data) return;
        if (data.site_title) {
          document.title = data.site_title;
        }
        if (data.favicon_data_uri) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }
          link.href = data.favicon_data_uri;
        }
      })
      .catch(() => {
        // silencioso: mantém título/ícone padrão do build se a API falhar
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
